module.exports = "<navbar app-user=\"$ctrl.appUser\"></navbar>\n<div id=\"alert-message\" class=\"alert with-navbar\"></div>\n<div class=\"container page-view\" ui-view></div>\n<ybsmallfooter class=\"page-footer\"></ybsmallfooter>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/page.html
// module id = 1005
// module chunks = 3